var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "close-change",
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F9FAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4164 17.2716C18.2664 17.1267 18.0654 17.0466 17.8569 17.0484C17.6483 17.0502 17.4488 17.1338 17.3013 17.2813C17.1538 17.4288 17.0702 17.6283 17.0683 17.8369C17.0665 18.0454 17.1467 18.2464 17.2916 18.3964L21.8854 22.9902L17.2908 27.5839C17.2148 27.6573 17.1542 27.7451 17.1126 27.8421C17.0709 27.9392 17.0489 28.0435 17.048 28.1492C17.0471 28.2548 17.0672 28.3595 17.1072 28.4573C17.1472 28.555 17.2063 28.6439 17.281 28.7185C17.3556 28.7932 17.4445 28.8523 17.5422 28.8923C17.64 28.9323 17.7447 28.9524 17.8503 28.9515C17.956 28.9506 18.0603 28.9286 18.1574 28.8869C18.2544 28.8453 18.3422 28.7847 18.4156 28.7087L23.0101 24.1149L27.6039 28.7087C27.7539 28.8536 27.9548 28.9338 28.1634 28.9319C28.372 28.9301 28.5715 28.8465 28.719 28.699C28.8665 28.5515 28.9501 28.352 28.9519 28.1434C28.9537 27.9349 28.8736 27.7339 28.7287 27.5839L24.1349 22.9902L28.7287 18.3964C28.8736 18.2464 28.9537 18.0454 28.9519 17.8369C28.9501 17.6283 28.8665 17.4288 28.719 17.2813C28.5715 17.1338 28.372 17.0502 28.1634 17.0484C27.9548 17.0466 27.7539 17.1267 27.6039 17.2716L23.0101 21.8654L18.4164 17.2708V17.2716Z",
    fill: "#0D8ECA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVideo);
export default __webpack_public_path__ + "static/media/close-video.a0b376fac6f9b2d5b580676592022da3.svg";
export { ForwardRef as ReactComponent };